module.exports = __webpack_public_path__ + "static/media/pause-button.b14ff59f.svg";